import { put, takeEvery } from 'redux-saga/effects';

import { AuthAction } from '../actions';
import { ProfileConstant } from '../constants';

export default function* () {
  yield takeEvery(
    ProfileConstant.SWITCH_OFFICE_PROFILE_SUCCESS,
    switchOfficeProfileSuccess,
  );
}

function* switchOfficeProfileSuccess(action) {
  yield put(AuthAction.setAuth(action?.payload));
}
